<script lang="ts">
  import { onMount } from 'svelte';
  import { isDemoTenant } from '../lib/hospital-preview.svelte';
  import { session } from '../lib/auth.svelte';
  import {
    fetchBillingStatus,
    SHOW_TRIAL_BANNER,
    WHATSAPP_LINK,
    type BillingStatus,
    trialUrgency,
  } from '../lib/billing';

  let status = $state<BillingStatus | null>(null);

  onMount(() => {
    void (async () => {
      const tid = session.value?.tenantId;
      if (!tid || isDemoTenant(tid) || !SHOW_TRIAL_BANNER) return;
      status = await fetchBillingStatus();
    })();
  });

  const urgency = $derived(trialUrgency(status?.diasRestantesTrial));
  const show = $derived(
    status?.estado === 'trial'
    && urgency !== 'none'
    && urgency !== 'expired'
  );
</script>

{#if show && status}
  <div class="trial-banner" class:warn={urgency === 'warn'} class:critical={urgency === 'critical'} class:info={urgency === 'info'}>
    {#if urgency === 'info'}
      <span>Prueba gratis: {status.diasRestantesTrial} días restantes</span>
    {:else}
      <span>
        {#if urgency === 'critical'}
          ⚠️ Su prueba vence en {status.diasRestantesTrial} día{status.diasRestantesTrial === 1 ? '' : 's'}.
        {:else}
          Le quedan {status.diasRestantesTrial} días de prueba.
        {/if}
        Active su plan para no perder acceso.
      </span>
      <a class="wa" href={WHATSAPP_LINK} target="_blank" rel="noopener">WhatsApp soporte</a>
      <a class="pay-link" href="/billing/trial-expired">Ver planes</a>
    {/if}
  </div>
{/if}

<style>
  .trial-banner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem;
    padding: 0.55rem 1rem;
    font-size: 0.85rem;
    border-bottom: 1px solid var(--border, #d6e7ea);
  }
  .info { background: #e6fafb; color: #005f73; }
  .warn { background: #fff8e6; color: #7a5a00; }
  .critical { background: #fff0f0; color: #9b1c1c; font-weight: 600; }
  .wa, .pay-link {
    margin-left: auto;
    font-weight: 600;
    color: inherit;
    text-decoration: underline;
  }
  .pay-link { margin-left: 0.5rem; }
</style>
